import { Brand, createBranded } from '@deltasierra/type-utilities';

/**
 * @deprecated
 * Instead use
 * ```
 * import { LocationId } from '@deltasierra/ids';
 * ```
 */
export type LocationId = Brand<number, 'LocationId'>;
export const LocationId = createBranded<LocationId>();
